import React from "react";
import { IconSize, IconProps } from "../theme";

interface GroupCheckboxProps {
  isChecked: boolean;
  color?: string;
  strokeColor?: string;
}

const GroupCheckbox: React.FC<GroupCheckboxProps & IconProps> = ({
  isChecked,
  size = IconSize.XL,
  color = "#071443",
  strokeColor = "#fff",
}) => {
  const viewBox = "0 0 24 24";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox={viewBox}
      fill="none"
    >
      {/* Background Circle */}
      <circle cx="12" cy="12" r="12" fill={color} />

      {/* Check Path */}
      {isChecked && (
        <path
          d="M7 12L11 16L17 9"
          fill="none"
          stroke={strokeColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
    </svg>
  );
};

export default GroupCheckbox;
